module.exports = __webpack_public_path__ + "img/left.a422d100.png";